import { render, staticRenderFns } from "./FilterSortWindow.vue?vue&type=template&id=5597c163"
import script from "./FilterSortWindow.vue?vue&type=script&lang=js"
export * from "./FilterSortWindow.vue?vue&type=script&lang=js"
import style0 from "./FilterSortWindow.vue?vue&type=style&index=0&id=5597c163&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports